import { SupplierSchedulePlanningToolComponent } from './supplier-schedule-planning-tool.component';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmeCommonModule } from '../../vme-common.module';
import { RouterModule, Routes } from '@angular/router';
import { InteractiveScheduleModule } from '../interactive-schedule/interactive-schedule.module';
import { VMEInteractiveScheduleModule } from '../interactive-schedule/vme-interactive-schedule/vme-interactive-schedule.module';

const routes: Routes = [
  {
    path: '',
    component: SupplierSchedulePlanningToolComponent,
    data: { title: 'Suppliers Planning Tool' },
  },
  {
    path: ':supplierId',
    component: SupplierSchedulePlanningToolComponent,
    data: { title: 'Supplier Planning Tool' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SupplierSchedulePlanningToolRoutingModule {}

@NgModule({
  imports: [
    SupplierSchedulePlanningToolRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    InteractiveScheduleModule,
    VMEInteractiveScheduleModule,
  ],
  declarations: [SupplierSchedulePlanningToolComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SupplierSchedulePlanningToolModule {}
